import { useAuth } from "@/contexts/AuthContext";

export function useSubscriptionStatus() {
  const { loading } = useAuth();

  return {
    hasActiveSubscription: true,
    reason: "active" as const,
    isOverdue: false,
    expiresAt: null as string | null,
    isLoading: loading,
  };
}
